var map = {
	"./BasisGrotesquePro-Black.woff": 625,
	"./BasisGrotesquePro-Light.woff": 627,
	"./BasisGrotesquePro-Regular.woff": 629,
	"./CaslonGraD.woff": 631,
	"./CircularPro-Black.woff": 634,
	"./CircularPro-BlackItalic.woff": 637,
	"./CircularPro-Bold.woff": 640,
	"./CircularPro-BoldItalic.woff": 643,
	"./CircularPro-Book.woff": 646,
	"./CircularPro-BookItalic.woff": 649,
	"./CircularPro-Medium.woff": 652,
	"./CircularPro-MediumItalic.woff": 655
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1176;



//////////////////
// WEBPACK FOOTER
// ./public/fonts ^\.\/.*\.woff$
// module id = 1176
// module chunks = 168707334958949